<!-- DArts Copyright/Link Banner -->

<template>
	
	<a href="http://www.dynamicarts.com/" target="_blank">
	<div class="banner-da-main">
		<div class="box-left">
			© 2001 - 2022<br/>
			Dynamic Arts
		</div>
		<div class="box-right">
			<UniIcon
				ico="logo_da"
				color="#369"
				fit="1"
				pad="0"
			/>
		</div>
	</div>
	</a>
	
</template>

<script>
export default {
}
</script>

<style scoped>
.banner-da-main {
	float: right;
	vertical-align: top;
	width: 140px;
	height: 40px;
	overflow: hidden;
	cursor: pointer;
	border-radius: 5px;
	border: solid 1px #999;
}

.box-left {
	display: inline-block;
	width: 90px;
	height: 40px;
	overflow: hidden;
	vertical-align: top;
	padding: 3px 0px 0px 5px;
	font-size: 13px;
	line-height: 16px;
	border: solid 0px #C30;
}

.box-right {
	float:right;
	width: 40px;
	height: 35px;
	overflow: hidden;
	vertical-align: top;
	font-size: 12px;
	border: solid 0px #000;
}

</style>
